// @flow
import BankTransferModal from './BankTransferModal'
export default BankTransferModal
